import {
  billingInquiry,
  settlementList
} from '@root/state/reducers/Settlement/settlementReducer';
import { ActionType } from '../../actions-types';
import { message } from 'antd';
import { Dispatch } from 'react';
import { Action } from '@root/state/actions/settlement';
import settlementService from '@root/modules/Warehouse/Settlement/Services/settlementService';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

export const handleSettlementList = (
  page: number,
  sort?: boolean,
  fromDt?: string,
  toDt?: string,
  filterBy?: string,
  searchBy?: string,
  filterInput?: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_SETTLEMENT_LIST
    });
    try {
      const resp = await settlementService.getSettlementBillingInquiries(
        page,
        sort,
        fromDt,
        toDt,
        filterBy,
        searchBy,
        filterInput
      );
      const payload = {
        count: resp.count,
        rowData: resp.data?.map((row: settlementList) => {
          return {
            ...row,
            key: row.id,
            IssuingDate: formatDateTime(row?.issuingDate)
          };
        })
      };
      dispatch({
        type: ActionType.GET_SETTLEMENT_LIST_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_SETTLEMENT_LIST_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

export const getTransactionInfo = () => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const resp = await settlementService.getSettlementAmountInfo();
      dispatch({
        type: ActionType.GET_AMOUNT_INFO_SUCCESS,
        payload: resp.data
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_AMOUNT_INFO_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// get billing inquiry detail

export const getBillingInquiryDetail = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_BILLING_INQUIRY_DETAIL
    });
    try {
      const resp = await settlementService.getBillingInquiryDetail(id);
      const payload = resp.data;
      dispatch({
        type: ActionType.GET_BILLING_INQUIRY_DETAIL_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_BILLING_INQUIRY_DETAIL_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// get customer lists

export const getCustomerLists = (searchInfo?: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_CUSTOMER_INFO
    });
    try {
      const resp = await settlementService.getCustomerInfo(searchInfo);
      const payload = resp.data;
      dispatch({
        type: ActionType.GET_CUSTOMER_INFO_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_CUSTOMER_INFO_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// get inquiry inbound infomation

export const getInquiryInboundInfo = (
  id: number,
  startDate: string,
  endDate: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.GET_INQUIRY_INBOUND_INFO });

    try {
      const resp = await settlementService.getInquiryInboundInfo(
        id,
        startDate,
        endDate
      );
      const payload = resp.data;
      dispatch({
        type: ActionType.GET_INQUIRY_INBOUND_INFO_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_INQUIRY_INBOUND_INFO_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

export const postCreateBillingInquiry = (bodyCreateBilling: billingInquiry) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.POST_BILLING_INQUIRY });
    try {
      const resp = await settlementService.postCreateBillingInquiry(
        bodyCreateBilling
      );
      const payload = resp.data;
      dispatch({
        type: ActionType.POST_BILLING_INQUIRY_SUCCESS,
        payload: payload
      });

      message.success('Create billing inquiry successfully');
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.POST_BILLING_INQUIRY_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

export const handleGetServiceList = (
  page: number,
  sort?: boolean,
  fromDt?: string,
  toDt?: string,
  filterBy?: string,
  searchBy?: string,
  filterInput?: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_SETTLEMENT_LIST
    });
    try {
      const resp = await settlementService.getServiceInquiryList(
        page,
        sort,
        fromDt,
        toDt,
        filterBy,
        searchBy,
        filterInput
      );
      const payload = {
        count: resp.count,
        rowData: resp.data?.map((row: settlementList) => {
          return {
            ...row,
            key: row.id,
            IssuingDate: formatDateTime(row?.issuingDate)
          };
        })
      };
      dispatch({
        type: ActionType.GET_SETTLEMENT_LIST_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_SETTLEMENT_LIST_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

export const getServiceDetail = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_BILLING_INQUIRY_DETAIL
    });
    try {
      const resp = await settlementService.getServiceInquiryDetail(id);
      const payload = resp.data;
      dispatch({
        type: ActionType.GET_BILLING_INQUIRY_DETAIL_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_BILLING_INQUIRY_DETAIL_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};
